//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum MoySkladProductsTableFilterColumn {
  /** Товар с тем же артикулом есть на Ozon. */
  onOzon = 0,
  /** Товар с тем же артикулом есть на Wildberries. */
  onWb = 1,
  /** Товар с тем же артикулом есть на Яндекс Маркете. */
  onYandexMarket = 2
}
